
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignArrowLeft as ObiSignArrowLeftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-arrow-left.js';
 
 
 

 
 export const ObiSignArrowLeft = createComponent({
   react: React,
   tagName: 'obi-sign-arrow-left',
   elementClass: ObiSignArrowLeftElement,
   events: {
     
   }
  });
 
 